// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"961ef7cf","977":"a91ffd57"}[chunkId] + ".chunk.js";
};